// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fieldset[data-v-9a1b13a6]{position:relative}.fieldset.has-error input[data-v-9a1b13a6]{border-color:#ff0040 !important}.fieldset input.round[data-v-9a1b13a6]{border-radius:100px}.fieldset .error-message[data-v-9a1b13a6]{color:#ff0040;text-align:right;font-size:14px;line-height:100%;position:absolute;top:0;transform:translateY(-50%);right:20px;padding:0 5px;background-color:#fff}.fieldset .round[data-v-9a1b13a6]{border-radius:100px !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
